import React from 'react'
import { Parallax } from 'react-parallax'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { about, about2, mobileAbout, mobileAbout2 } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobileAbout} w="100%" alt="aboutImageMobile" />
          <CFImage src={mobileAbout2} w="100%" alt="aboutImageMobile" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center w="100%" maxWidth="1400px">
          <CFImage src={about} w="100%" alt="about Image" />
          <CFImage src={about2} w="100%" alt="about Image" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
